import { useEffect, useState } from 'react';
// import { LineChart } from '@mui/x-charts/LineChart';
import { BarChart } from '@mui/x-charts/BarChart';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import { TextField, Button, Box, Typography, Container, Snackbar
  , Radio, RadioGroup, FormControlLabel, Checkbox, Dialog, CircularProgress } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  LabelList, Legend,
  ResponsiveContainer,
} from "recharts";
import { useGetDataChartsMutation } from '../services/home';
import { useGetSalesProcessMutation, useGetSalesProcessMonthsMutation, useGetSalesProcessPartialsMutation } from '../services/consumer';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import moment from 'moment';

export default function FYourBeauty() {
  const [getSalesProcess, dataSalesProcess] = useGetSalesProcessMutation();
  const [getSalesProcessMonths, dataSalesProcessMonths] = useGetSalesProcessMonthsMutation();
  const [getSalesProcessPartials, dataSalesProcessPartials] = useGetSalesProcessPartialsMutation();
  const [getDataCharts, dataCharts] = useGetDataChartsMutation();
  const [processMonthsTotal, setProcessMonthsTotal] = useState([]);
  const [processMonthsD2C, setProcessMonthsD2C] = useState([]);
  const [processMonthsEcom, setProcessMonthsEcom] = useState([]);
  const [processMTotal, setProcessMTotal] = useState({xAxis: [], data: []});
  const [processMD2C, setProcessMD2C] = useState({xAxis: [], data: []});
  const [processMEcom, setProcessMEcom] = useState({xAxis: [], data: []});
  const initProcess = {total: {target: 0, actual: 0, percent: 0}, d2c: {target: 0, actual: 0, percent: 0}, ecom: {target: 0, actual: 0, percent: 0}};
  const [saleProcess, setSaleProcess] = useState({...initProcess});
  const initProcessP = {LoyalList: {data: [0, 0, 0, 0], label: 'LoyalList'}, StyleList: {data: [0, 0, 0, 0], label: 'StyleList'}, Redeem: {data: [0, 0, 0, 0], label: 'Redeem'}, WOM: {data: [0, 0, 0, 0], label: 'WOM'}};
  const [processPTotal, setProcessPTotal] = useState(initProcessP);
  const [processPD2C, setProcessPD2C] = useState(initProcessP);
  const [processPEcom, setProcessPEcom] = useState(initProcessP);

  const margin = { right: 24 };

  useEffect(() => {
    getSalesProcess();
    getSalesProcessMonths();
    getSalesProcessPartials();
    // getDataCharts({'year': 2025});
  }, []);

  useEffect(() => {
    if(dataSalesProcess.data)
    {
      const dt = JSON.parse(dataSalesProcess.data);
      let initP = {...initProcess};
      dt && dt.map(m=>{
        if(m.Channel == 'Total'){
          initP.total = {target: m.Target, actual: m.Actual, percent: m.Target?(Math.round(m.Actual/m.Target*100*100)/100):0};
        }
        else if(m.Channel == 'D2C'){
          initP.d2c = {target: m.Target, actual: m.Actual, percent: m.Target?(Math.round(m.Actual/m.Target*100*100)/100):0};
        }
        else if(m.Channel == 'Ecom'){
          initP.ecom = {target: m.Target, actual: m.Actual, percent: m.Target?(Math.round(m.Actual/m.Target*100*100)/100):0};
        }
      })
      setSaleProcess(initP);
    }
  }, [dataSalesProcess]);

  useEffect(() => {
    if(dataSalesProcessMonths.data)
    {
      const dt = JSON.parse(dataSalesProcessMonths.data);
      let channel = [];
      let xLabels = [];
      let data = [], dataD2C = [], dataEcom = [];
      const curDate = new Date();
      const dateMonth = new Date(curDate.getFullYear(), curDate.getMonth(), 1);
      dt.map(m=>{
        dateMonth.setMonth(m.Month-1);
        const monthName = dateMonth.toLocaleString('default', { month: 'short' });

        let item = {month: monthName, target: 0, actual: 0, fybstyle: 0};
        let itemIndex = data.findIndex(f=>f.month == monthName);
        if(itemIndex >= 0)
          item = data[itemIndex];
        if(m.Channel == "Target") item.target = Math.round(m.Amount/1000000);
        else if(m.Channel == "Actual") item.actual = Math.round(m.Amount/1000000)||(m.Month==9?0:NaN);
        else if(m.Channel == "FYBStyle") item.fybstyle = Math.round(m.Amount/1000000)||(m.Month==9?0:NaN);
        if(itemIndex < 0)
          data.push(item);

        let item2 = {month: monthName, target: 0, actual: 0, fybstyle: 0};
        let itemIndex2 = dataD2C.findIndex(f=>f.month == monthName);
        if(itemIndex2 >= 0)
          item2 = dataD2C[itemIndex2];
        if(m.Channel == "Target") item2.target = Math.round(m.D2CAmount/1000000);
        else if(m.Channel == "Actual") item2.actual = Math.round(m.D2CAmount/1000000)||(m.Month==9?0:NaN);
        else if(m.Channel == "FYBStyle") item2.fybstyle = Math.round(m.D2CAmount/1000000)||(m.Month==9?0:NaN);
        if(itemIndex2 < 0)
          dataD2C.push(item2);

        let item3 = {month: monthName, target: 0, actual: 0, fybstyle: 0};
        let itemIndex3 = dataEcom.findIndex(f=>f.month == monthName);
        if(itemIndex3 >= 0)
          item3 = dataEcom[itemIndex3];
        if(m.Channel == "Target") item3.target = Math.round(m.EcomAmount/1000000);
        else if(m.Channel == "Actual") item3.actual = Math.round(m.EcomAmount/1000000)||(m.Month==9?0:NaN);
        else if(m.Channel == "FYBStyle") item3.fybstyle = Math.round(m.EcomAmount/1000000)||(m.Month==9?0:NaN);
        if(itemIndex3 < 0)
          dataEcom.push(item3);
      });
      
      setProcessMonthsTotal(data);
      setProcessMonthsD2C(dataD2C);
      setProcessMonthsEcom(dataEcom);

      const curTarget = dt.find(f=>f.Month == moment().month()+1 && f.Channel == 'Target');
      const curActual = dt.find(f=>f.Month == moment().month()+1 && f.Channel == 'Actual');
      setProcessMTotal({xAxis: ['Target', 'Actual'], data: [curTarget?curTarget.Amount:0, curActual?curActual.Amount:0]});
      setProcessMD2C({xAxis: ['Target', 'Actual'], data: [curTarget?curTarget.D2CAmount:0, curActual?curActual.D2CAmount:0]});
      setProcessMEcom({xAxis: ['Target', 'Actual'], data: [curTarget?curTarget.EcomAmount:0, curActual?curActual.EcomAmount:0]});
    }
  }, [dataSalesProcessMonths]);

  useEffect(() => {
    if(dataSalesProcessPartials.data)
    {
      const dt = JSON.parse(dataSalesProcessPartials.data);
      let initP = JSON.parse(JSON.stringify(initProcessP));
      initP.LoyalList.data = dt && dt.filter(f => f.Channel=='LoyalList').map(m => m.Amount||0);
      initP.StyleList.data = dt && dt.filter(f => f.Channel=='StyleList').map(m => m.Amount||0);
      initP.Redeem.data = dt && dt.filter(f => f.Channel=='Redeem').map(m => m.Amount||0);
      initP.WOM.data = dt && dt.filter(f => f.Channel=='WOM').map(m => m.Amount||0);
      
      let initPD2C = JSON.parse(JSON.stringify(initProcessP));
      initPD2C.LoyalList.data = dt && dt.filter(f => f.Channel=='LoyalList').map(m => m.D2CAmount||0);
      initPD2C.StyleList.data = dt && dt.filter(f => f.Channel=='StyleList').map(m => m.D2CAmount||0);
      initPD2C.Redeem.data = dt && dt.filter(f => f.Channel=='Redeem').map(m => m.D2CAmount||0);
      initPD2C.WOM.data = dt && dt.filter(f => f.Channel=='WOM').map(m => m.D2CAmount||0);

      let initPEcom = JSON.parse(JSON.stringify(initProcessP));
      initPEcom.LoyalList.data = dt && dt.filter(f => f.Channel=='LoyalList').map(m => m.EcomAmount||0);
      initPEcom.StyleList.data = dt && dt.filter(f => f.Channel=='StyleList').map(m => m.EcomAmount||0);
      initPEcom.Redeem.data = dt && dt.filter(f => f.Channel=='Redeem').map(m => m.EcomAmount||0);
      initPEcom.WOM.data = dt && dt.filter(f => f.Channel=='WOM').map(m => m.EcomAmount||0);

      setProcessPTotal(initP);
      setProcessPD2C(initPD2C);
      setProcessPEcom(initPEcom);
    }
  }, [dataSalesProcessPartials]);

  const LineMonth = ({ data }) => (
    <ResponsiveContainer width="100%" height={200}>
      <LineChart data={data} margin={{ top: 10, right: 20, bottom: 0, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip formatter={(value) => value.toLocaleString()} />
        <Legend
          verticalAlign="top"
          align="center"
          iconType="plainline"
          iconSize={30}
          wrapperStyle={{
            fontSize: 13,
            fontWeight: 500,
            top: -5
          }}
        />
        <Line
          type="monotone"
          dataKey="target"
          name="1.Target"
          stroke="#1976d2"
          strokeWidth={3}
          dot={{ r: 4 }}
        >
          <LabelList
            dataKey="target"
            position="top"
            content={(props) => (
              <text
                x={props.x}
                y={props.y - 5}
                fill="#1976d2"
                fontSize={13}
                fontWeight={500}
                textAnchor="middle"
              >
                {props.value.toLocaleString()}
              </text>
            )}
          />
        </Line>

        <Line
          type="monotone"
          dataKey="actual"
          name="2.Actual"
          stroke="#f9a825"
          strokeWidth={3}
          dot={{ r: 4 }}
        >
          <LabelList
            dataKey="actual"
            position="top"
            content={(props) => (
              <text
                x={props.x}
                y={props.y - 5}
                fill="#f9a825"
                fontSize={13}
                fontWeight={500}
                textAnchor="middle"
              >
                {props.value.toLocaleString()}
              </text>
            )}
          />
        </Line>

        <Line
          type="monotone"
          dataKey="fybstyle"
          name="3.FYB Style"
          stroke="#ff1205ff"
          strokeWidth={3}
          dot={{ r: 4 }}
        >
          <LabelList
            dataKey="fybstyle"
            position="top"
            content={(props) => (
              <text
                x={props.x}
                y={props.y - 5}
                fill="#ff1205ff"
                fontSize={13}
                fontWeight={500}
                textAnchor="middle"
              >
                {props.value.toLocaleString()}
              </text>
            )}
          />
        </Line>
      </LineChart>
    </ResponsiveContainer>
  );

  return (
    <div style={{padding: '0 10px'}}>
    <Container maxWidth="sm">
      <Grid container spacing={1}>
        <label style={{fontWeight: 'bold', width: '100%', marginTop: '10px'}}>
          TOTAL PROJECT
        </label>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Gauge width={200} value={saleProcess.total.percent} startAngle={-100} endAngle={100} 
              innerRadius="66%" outerRadius="100%"
              text={({ value, valueMax }) => 
                `${Math.round((value/valueMax*100)*100)/100} %`
              }
              sx={{
                [`& .${gaugeClasses.valueText}`]: {
                  fontSize: 20,
                  transform: 'translate(0px, -10px)'
                },
                [`& .${gaugeClasses.valueArc}`]: {
                  fill: (saleProcess.total.percent<50?'red':saleProcess.total.percent>80?'#52b202':'orange'),
                },
              }}/>
            <Typography sx={{position: 'relative', bottom: '15px'}}>
              <label style={{color: saleProcess.total.percent<50?'red':saleProcess.total.percent>80?'#52b202':'orange'}}>
                {saleProcess.total.actual.toLocaleString('en-US')}
              </label> / {saleProcess.total.target.toLocaleString('en-US')}
            </Typography>
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '15px'}}>
              TOTAL
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Gauge width={200} value={saleProcess.d2c.percent} startAngle={-100} endAngle={100} 
              innerRadius="66%" outerRadius="100%"
              text={({ value, valueMax }) => 
                `${Math.round((value/valueMax*100)*100)/100} %`
              }
              sx={{
                [`& .${gaugeClasses.valueText}`]: {
                  fontSize: 20,
                  transform: 'translate(0px, -10px)'
                },
                [`& .${gaugeClasses.valueArc}`]: {
                  fill: (saleProcess.d2c.percent<50?'red':saleProcess.d2c.percent>80?'#52b202':'orange'),
                },
              }}/>
            <Typography sx={{position: 'relative', bottom: '15px'}}>
              <label style={{color: saleProcess.d2c.percent<50?'red':saleProcess.d2c.percent>80?'#52b202':'orange'}}>
                {saleProcess.d2c.actual.toLocaleString('en-US')}
              </label> / {saleProcess.d2c.target.toLocaleString('en-US')}
            </Typography>
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '15px'}}>
              D2C
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Gauge width={200} value={saleProcess.ecom.percent} startAngle={-100} endAngle={100} 
              innerRadius="66%" outerRadius="100%"
              text={({ value, valueMax }) => 
                `${Math.round((value/valueMax*100)*100)/100} %`
              }
              sx={{
                [`& .${gaugeClasses.valueText}`]: {
                  fontSize: 20,
                  transform: 'translate(0px, -10px)'
                },
                [`& .${gaugeClasses.valueArc}`]: {
                  fill: (saleProcess.ecom.percent<50?'red':saleProcess.ecom.percent>80?'#52b202':'orange'),
                },
              }}/>
            <Typography sx={{position: 'relative', bottom: '15px'}}>
              <label style={{color: saleProcess.ecom.percent<50?'red':saleProcess.ecom.percent>80?'#52b202':'orange'}}>
                {saleProcess.ecom.actual.toLocaleString('en-US')}
              </label> / {saleProcess.ecom.target.toLocaleString('en-US')}
            </Typography>
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '15px'}}>
              ECOM
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <hr style={{border: 'none', borderTop: '1px dashed #ccc', height: '0'}}/>
      <Grid container spacing={1}>
        <label style={{fontWeight: 'bold', width: '100%'}}>
          MONTHLY ACHIEVEMENT
        </label>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
           {/* <LineChart
              height={200}
              series={processMonthsTotal.data}
              xAxis={[{ scaleType: 'point', data: processMonthsTotal.xLabels }]}
              yAxis={[{ width: 50 }]}
              margin={margin}
              sx={{width: '100%'}}
            /> */}
            <LineMonth data={processMonthsTotal}/>
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '10px'}}>
              TOTAL
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {/* <LineChart
              height={200}
              series={processMonthsD2C.data}
              xAxis={[{ scaleType: 'point', data: processMonthsD2C.xLabels }]}
              yAxis={[{ width: 50 }]}
              margin={margin}
              sx={{width: '100%'}}
            /> */}
            <LineMonth data={processMonthsD2C}/>
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '10px'}}>
              D2C
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {/* <LineChart
              height={200}
              series={processMonthsEcom.data}
              xAxis={[{ scaleType: 'point', data: processMonthsEcom.xLabels }]}
              yAxis={[{ width: 50 }]}
              margin={margin}
              sx={{width: '100%'}}
            /> */}
            <LineMonth data={processMonthsEcom}/>
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '10px'}}>
              ECOM
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <hr style={{border: 'none', borderTop: '1px dashed #ccc', height: '0'}}/>
      <Grid container spacing={1}>
        <label style={{fontWeight: 'bold', width: '100%'}}>
          CURRENT MONTH
        </label>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <BarChart
              height={200}
              xAxis={[
                {
                  id: "barCategories",
                  data: processMTotal.xAxis,
                  scaleType: "band",
                  colorMap: {
                    type: "ordinal",
                    values: processMTotal.xAxis,
                    colors: ['#4254fb', '#ffb422'],
                  },
                },
              ]}
              series={[{ data: processMTotal.data }]}
              yAxis={[{ width: 50 }]}
              margin={margin}
              sx={{width: '100%'}}
            />
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '10px'}}>
              TOTAL {moment().startOf('M').format("MMM DD")} - {moment().format("MMM DD")}
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <BarChart
              height={200}
              xAxis={[
                {
                  id: "barCategories",
                  data: processMD2C.xAxis,
                  scaleType: "band",
                  colorMap: {
                    type: "ordinal",
                    values: processMD2C.xAxis,
                    colors: ['#4254fb', '#ffb422'],
                  },
                },
              ]}
              series={[{ data: processMD2C.data }]}
              yAxis={[{ width: 50 }]}
              margin={margin}
              sx={{width: '100%'}}
            />
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '10px'}}>
              D2C {moment().startOf('M').format("MMM DD")} - {moment().format("MMM DD")}
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <BarChart
              height={200}
              xAxis={[
                {
                  id: "barCategories",
                  data: processMEcom.xAxis,
                  scaleType: "band",
                  colorMap: {
                    type: "ordinal",
                    values: processMEcom.xAxis,
                    colors: ['#4254fb', '#ffb422'],
                  },
                },
              ]}
              series={[{ data: processMEcom.data }]}
              yAxis={[{ width: 50 }]}
              margin={margin}
              sx={{width: '100%'}}
            />
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '10px'}}>
              ECOM {moment().startOf('M').format("MMM DD")} - {moment().format("MMM DD")}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <hr style={{border: 'none', borderTop: '1px dashed #ccc', height: '0'}}/>
      <Grid container spacing={1}>
        <label style={{fontWeight: 'bold', width: '100%'}}>
          FYB CRITERIA
        </label>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <BarChart
              height={200}
              series={[
                { ...processPTotal.LoyalList, stack: 'total' },
                { ...processPTotal.StyleList, stack: 'total' },
                { ...processPTotal.Redeem, stack: 'total' },
                { ...processPTotal.WOM, stack: 'total' }
              ]}
              xAxis={[{label: '', data: ['Sep', 'Oct', 'Now', 'Dec']}]}
              margin={margin}
              sx={{width: '100%'}}
            />
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '10px'}}>
              TOTAL
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <BarChart
              height={200}
              series={[
                { ...processPD2C.LoyalList, stack: 'total' },
                { ...processPD2C.StyleList, stack: 'total' },
                { ...processPD2C.Redeem, stack: 'total' },
                { ...processPD2C.WOM, stack: 'total' }
              ]}
              xAxis={[{label: '', data: ['Sep', 'Oct', 'Now', 'Dec']}]}
              margin={margin}
              sx={{width: '100%'}}
            />
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '10px'}}>
              D2C
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <BarChart
              height={200}
              series={[
                { ...processPEcom.LoyalList, stack: 'total' },
                { ...processPEcom.StyleList, stack: 'total' },
                { ...processPEcom.Redeem, stack: 'total' },
                { ...processPEcom.WOM, stack: 'total' }
              ]}
              xAxis={[{label: '', data: ['Sep', 'Oct', 'Now', 'Dec']}]}
              margin={margin}
              sx={{width: '100%'}}
            />
            <Typography component="h1" variant="h6" sx={{position: 'relative', bottom: '10px'}}>
              ECOM
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
    </div>
  )
}